import { css } from '@linaria/core';
export const DotLoader = ({
  text
}: {
  text: string;
}) => {
  return <div className={container} data-testid="default-loading-ui">
      <span>{text}</span>
      <span className="dot-spinner">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </div>;
};
const container = "omponents__DotLoader__index_tsx-container-cqyg4kt";

require("./index.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./index.tsx");